import { Testimonials } from "../components/Testimonials";

export function TestimonialsPage() {
  return <Testimonials />;
}
